<template>
    <AuthCard>
        <template v-slot:title>
            <h1>Register</h1>
        </template>
        <template v-slot:form>
            <ValidationObserver v-slot="{ handleSubmit }">
                <form action="" @submit.prevent="handleSubmit(submit)">
                    <Alert type="error"
                           v-if="error"
                           :contentList="message"
                    />

                    <ValidationProvider name="name" rules="required|max:255" v-slot="{ errors }">
                        <v-text-field
                                id="name"
                                name="name"
                                label="Name"
                                v-model="form.name"
                                :error-messages="errors[0]"
                                outlined
                                :dense="$vuetify.breakpoint.xsOnly"
                        ></v-text-field>
                    </ValidationProvider>

                    <ValidationProvider name="email" rules="required|email|max:255" v-slot="{ errors }">
                        <v-text-field
                                id="email"
                                name="email"
                                label="Email Address"
                                v-model="form.email"
                                outlined
                                :dense="$vuetify.breakpoint.xsOnly"
                                :error-messages="errors[0]"
                        ></v-text-field>
                    </ValidationProvider>

                    <ValidationProvider name="password" rules="required|min:8|max:255" v-slot="{ errors }">
                        <v-text-field
                                type="password"
                                id="password"
                                name="password"
                                label="Password"
                                v-model="form.password"
                                :error-messages="errors[0]"
                                outlined
                                :dense="$vuetify.breakpoint.xsOnly"
                        ></v-text-field>
                    </ValidationProvider>

                    <v-btn
                            width="100%"
                            height="48px"
                            color="primary"
                            type="submit"
                            class="mb-4"
                    >
                        Register
                    </v-btn>
                </form>
                <v-card-actions>
                    <v-btn text :x-small="$vuetify.breakpoint.xsOnly" to="/login">Login</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn text :x-small="$vuetify.breakpoint.xsOnly" to="/forgot-password">Forgot Password?</v-btn>
                </v-card-actions>
            </ValidationObserver>
        </template>
    </AuthCard>
</template>
<script>
import { mapActions, mapMutations } from 'vuex';
import router from '../../router/routes';
import Alert from '@/components/Auth/Common/Alert';
import AuthCard from '@/components/Auth/Common/AuthCard';

export default {
    name: 'Register',
    components: { AuthCard, Alert },
    data() {
        return {
            error: false,
            form: {
                name: '',
                email: '',
                password: '',
                profession_id: 1,
            },
            message: '',
        };
    },

    methods: {
        ...mapActions({
            register: 'auth/register',
        }),

        ...mapMutations({
            overlayToggle: 'overlay/toggle'
        }),

        submit() {
            this.error = false;
            this.overlayToggle(true);

            this.register(this.form)
                .then(() => {
                    router.push({ name: 'Dashboard' });
                })

                .catch((error) => {
                    this.message = error.data.errors;
                    this.error = true;
                    this.overlayToggle(false);
                });
        },
    },
};
</script>
